'use strict';

import CONST from 'Util/constants';
import { getFieldValidationMessage } from 'Components/form/form';

class VZFormFeedback extends HTMLElement {
    constructor() {
        super();
        this.supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
    }

    show(form) {
        const formFields = [...form.querySelectorAll(`${CONST.selectors.form.input},${CONST.selectors.form.select}`)];
        const invalidsFields = formFields
            .map((field) => {
                if (!field.checkValidity()) {
                    field.classList.add(CONST.classes.invalid);
                    field.classList.remove(CONST.classes.valid);
                } else {
                    field.classList.add(CONST.classes.valid);
                    field.classList.remove(CONST.classes.invalid);
                }
                return getFieldValidationMessage(field);
            })
            .filter((message) => {
                return message;
            });

        this.innerHTML = this.constructor.template(form.getAttribute('data-error'), invalidsFields);
        this.scrollToFeedback();
    }

    static template(title, fieldErrors) {
        const errors = fieldErrors.reduce((result, errorMessage) => {
            return `
                ${result}
                <div class="d-flex text-primary">
                    <span class="h4 pe-2 lh-1"><i class="icon icon-warning"></i></span>
                    ${errorMessage}
                </div>`;
        }, '');

        return `
            <div class="bg-red border-top border-bottom">
                <div class="container">
                    <div class="row">
                        <div class="col-12 py-3 py-md-5">
                            <p class="branded font-weight-bold">${title}</p>
                            ${errors}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    scrollToFeedback() {
        if (this.supportsNativeSmoothScroll) {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        } else {
            window.scrollTop = 0;
            window.scrollTo(0, 0);
        }
    }
}

export default window.customElements.get('vz-form-feedback') || VZFormFeedback;
if (!window.customElements.get('vz-form-feedback')) {
    window.customElements.define('vz-form-feedback', VZFormFeedback);
}
